export const highlightTextColor = "#106AC9";
export const secondaryHighlightColor = "#D0E7FE";
